import SelectConfig from '../components/common/diagramConfigComponents/SelectConfig'
import Checkbox from '../components/common/diagramConfigComponents/Checkbox'
import Spinner from '../components/common/diagramConfigComponents/Spinner'
import ColorPicker from '../components/common/diagramConfigComponents/ColorPicker'
import FontStyle from '../components/common/diagramConfigComponents/FontStyle'
import TextAlign from '../components/common/diagramConfigComponents/TextAlign'
import Border from '../components/common/diagramConfigComponents/Border'
import Slider from '@views/dataview-refactor/chartsdk/components/propComponents/Slider'
import { getCurrentDashboardTheme } from '@constants/echart'

const DARKEN_COLOR = {
  text: '#A7C7FA',
  border: '#265686',
}
const LIGHTEN_COLOR = {
  text: '#202437',
  border: '#EDEDED',
}

const getDefaultColor = (key) => {
  const theme = getCurrentDashboardTheme()
  const darkenTheme = ['tech_blue', 'colorful_blue'].includes(theme)
  const color = darkenTheme ? DARKEN_COLOR : LIGHTEN_COLOR
  return color[key]
}

export default () =>  ({
  title: '模拟运算表',
  field: 'dataTable',
  spread: false,
  show: false,
  items: [
    {
      field: 'tablePosition',
      label: '显示位置',
      component: {
        component: SelectConfig,
        props: {
          options: [
            { value: 'top', text: '顶部' },
            { value: 'bottom', text: '底部' },
            { value: 'left', text: '左侧' },
            { value: 'right', text: '右侧' },
          ]
        }
      },
      data: 'right'
    },
    {
      field: 'proportion',
      label: '显示比例',
      component: {
        component: Slider,
        props: {
          min: 10,
          max: 50,
          step: 1
        }
      },
      data: 30
    },
    {
      field: 'hiddenHeader',
      label: '隐藏表头',
      component: Checkbox,
      data: false
    },
    {
      field: 'textStyle',
      label: '文本样式',
      spread: false,
      items: [
        {
          field: 'fontSize',
          label: '字号',
          component: {
            component: Spinner,
            props: {
              min: 6
            }
          },
          data: 12
        },
        {
          field: 'color',
          label: '文本颜色',
          theme_controled: true,
          component: ColorPicker,
          data: getDefaultColor('text'),
        },
        {
          field: 'lineHeight',
          label: '行高',
          component: {
            component: Spinner,
            props: {
              min: 12
            }
          },
          data: 24
        },
        {
          label: '样式',
          field: 'fontStyle',
          component: FontStyle,
          data: {
            fontWeight: 'normal',   //bold, normal
            fontStyle: 'normal',    //italic, normal
            textDecoration: 'none'  //underline, none
          }
        },
        {
          field: 'textAlign',
          label: '对齐方式',
          component: TextAlign,
          data: 'center'
        },
      ]
    },
    {
      field: 'splitLine',
      label: '分割线',
      show: {
        field: 'checked',
        data: true
      },
      items: [
        {
          field: 'border',
          component: Border,
          theme_controled: true,
          data: {
            borderColor: getDefaultColor('border'),
            borderWidth: 1,
            borderStyle: 'solid',
          }
        }
      ]
    }
  ]
})
